import { CircleAlert } from 'lucide-react'
import Button from './Button.jsx'

export default function ErrorState({ title = 'Unable to load this information', message, onRetry, compact = false }) {
  return (
    <div className={`error-state ${compact ? 'error-state-compact' : ''}`} role="alert">
      <CircleAlert aria-hidden="true" />
      <div><h3>{title}</h3>{message && <p>{message}</p>}</div>
      {onRetry && <Button variant="secondary" onClick={onRetry}>Retry</Button>}
    </div>
  )
}
